import { render, staticRenderFns } from "./PostEditoCreateModalConfirmStopCustom.vue?vue&type=template&id=63ada5c1&scoped=true&"
import script from "./PostEditoCreateModalConfirmStopCustom.vue?vue&type=script&lang=js&"
export * from "./PostEditoCreateModalConfirmStopCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ada5c1",
  null
  
)

export default component.exports